module.exports = __webpack_public_path__ + "img/box1_icon1.fd605f41.png";